import YYTabs from './tabs.vue'
import YYTabPane from './pane.vue'
export { YYTabs, YYTabPane }


// WEBPACK FOOTER //
// ./src/components/base/tabs/index.js